__turbopack_context__.v({
  "fancy-radio-list": "ProducerContactRequestForm-module-scss-module__V2_e4q__fancy-radio-list",
  "form": "ProducerContactRequestForm-module-scss-module__V2_e4q__form",
  "icon": "ProducerContactRequestForm-module-scss-module__V2_e4q__icon",
  "radio-input": "ProducerContactRequestForm-module-scss-module__V2_e4q__radio-input",
  "radio-wrapper": "ProducerContactRequestForm-module-scss-module__V2_e4q__radio-wrapper",
});
